(() => {
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-leia-menu-toggle]');
    if (!toggle) return;
    event.preventDefault();
    event.stopPropagation();
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    document.querySelectorAll('[data-leia-menu-toggle]').forEach(button => {
      const expanded = button === toggle && open;
      button.setAttribute('aria-expanded', String(expanded));
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = !expanded;
    });
  }, true);
  const dialog = document.getElementById('LeiaRegionDialog');
  const form = document.getElementById('LeiaMarketForm');
  if (!dialog || !form || !dialog.showModal) return;
  const currencySelect = document.getElementById('LeiaCurrency');
  const currencyField = dialog.querySelector('[data-leia-currency-field]');
  const error = dialog.querySelector('[data-leia-region-error]');
  const save = dialog.querySelector('[type="submit"]');
  const initialCountry = form.elements.country_code.value;
  const initialLanguage = form.elements.language_code.value;
  let opener;
  let priorOverflow;
  let applying = false;
  let suppressEscapeUp = false;
  let converter;
  const getCurrency = () => converter?.querySelector('.bucks-selected')?.textContent.trim();
  const syncCheckoutLocale = () => {
    try {
      localStorage.setItem('sel-autodetect-country', form.elements.country_code.value);
      localStorage.setItem('sel-autodetect-lang', form.elements.language_code.value);
    } catch (_) { /* Browsing remains available if storage is restricted. */ }
  };
  syncCheckoutLocale();
  const updateSummary = () => {
    const code = getCurrency();
    if (!code) return;
    document.querySelectorAll('[data-leia-currency-code]').forEach(el => {
      if (el.textContent !== code) el.textContent = code;
    });
    if (!dialog.open && currencySelect.querySelector(`option[value="${code}"]`)) currencySelect.value = code;
  };
  const connectConverter = () => {
    const widget = document.querySelector('.buckscc-currency-box, .buckscc-floating-box');
    if (!widget?.querySelector('.bucks-selected')) return;
    converter = widget;
    const options = [...widget.querySelectorAll('select option')];
    if (!options.length) return;
    const signature = options.map(option => option.value).join(',');
    if (currencySelect.dataset.options !== signature) {
      currencySelect.replaceChildren(...options.map(option => new Option(option.textContent, option.value)));
      currencySelect.dataset.options = signature;
    }
    const current = getCurrency();
    if (current && ![...currencySelect.options].some(option => option.value === current)) {
      currencySelect.add(new Option(current, current));
    }
    if (!dialog.open && current) currencySelect.value = current;
    currencySelect.disabled = false;
    currencyField.hidden = false;
    document.body.classList.add('leia-region-converter-ready');
    updateSummary();
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; connectConverter(); });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  connectConverter();
  document.querySelectorAll('[data-leia-region-open]').forEach(button => { button.hidden = false; });
  document.addEventListener('click', event => {
      const button = event.target.closest('[data-leia-region-open]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      opener = button;
      form.elements.country_code.value = initialCountry;
      form.elements.language_code.value = initialLanguage;
      error.hidden = true;
      const current = getCurrency();
      if (current) currencySelect.value = current;
      priorOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      dialog.showModal();
  }, true);
  dialog.querySelector('[data-leia-region-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('cancel', event => {
    event.preventDefault();
    suppressEscapeUp = true;
    dialog.close();
  });
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && suppressEscapeUp) {
      event.stopPropagation();
      suppressEscapeUp = false;
    }
  }, true);
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = priorOverflow || '';
    const menu = opener?.closest('#menu-drawer');
    if (menu && typeof trapFocus === 'function') trapFocus(menu.closest('details') || menu, opener);
    opener?.focus({ preventScroll: true });
    updateSummary();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (applying) return;
    applying = true;
    save.disabled = true;
    error.hidden = true;
    try {
      const code = currencySelect.value;
      if (converter && code && code !== getCurrency()) {
        const option = [...converter.querySelectorAll('.buckscc-select-options li[rel]')].find(item => item.getAttribute('rel') === code);
        if (!option) throw new Error('Currency unavailable');
        option.click();
        const started = performance.now();
        while (getCurrency() !== code) {
          if (performance.now() - started > 3500) throw new Error('Currency did not update');
          await new Promise(resolve => setTimeout(resolve, 50));
        }
        updateSummary();
      }
      syncCheckoutLocale();
      if (form.elements.country_code.value !== initialCountry || form.elements.language_code.value !== initialLanguage) {
        if (form.elements.return_to) form.elements.return_to.value = window.location.pathname + window.location.search;
        HTMLFormElement.prototype.submit.call(form);
      } else {
        dialog.close();
      }
    } catch (_) {
      error.hidden = false;
    } finally {
      applying = false;
      save.disabled = false;
    }
  });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
